import { useTheme } from '@/hooks/useTheme';
import logoBlack from '@/assets/logo/rxfood-logo-screen-black.svg';
import logoYellow from '@/assets/logo/rxfood-logo-screen-yellow.svg';

/**
 * Theme-aware RxFood mark. Picks the yellow variant on the dark theme
 * so the brand reads warm against the charcoal sidebar; uses the black
 * variant on every other theme (light backgrounds).
 */
type Props = {
  /** Tailwind size utility for the square mark — defaults to `h-6 w-6`
   *  to match the previous sidebar placeholder. */
  className?: string;
};

export const BrandMark = ({ className = 'h-6 w-6' }: Props) => {
  const { theme } = useTheme();
  const src = theme === 'dark' ? logoYellow : logoBlack;
  return (
    <span className={`inline-flex shrink-0 items-center justify-center ${className}`}>
      <img src={src} alt="RxFood" className="h-full w-full object-contain" />
    </span>
  );
};
